import TableComponent from './table';
export default TableComponent;
